import { Search } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { DateRangePicker } from '@/components/ui/date-range-picker'
import type { DateRangeValue } from '@/components/ui/date-range-picker'
import { Select } from '@/components/ui/select'
import { FilterFormWrapper } from '@/components/FilterFormWrapper'

export interface EventFilterValues {
  keySearch: string
  unitId: string | undefined
  status: number | undefined
  time: DateRangeValue | undefined
  timeUpdate: DateRangeValue | undefined
}

interface EventFilterPanelProps {
  values: EventFilterValues
  onChange: (values: EventFilterValues) => void
  onSearch: () => void
  showUnitColumn: boolean
}

export function EventFilterPanel({
  values,
  onChange,
  onSearch,
}: EventFilterPanelProps) {
  function set<TKey extends keyof EventFilterValues>(
    key: TKey,
    value: EventFilterValues[TKey],
  ) {
    onChange({ ...values, [key]: value })
  }

  return (
    <FilterFormWrapper
      onSearch={onSearch}
      className="rounded-xl border border-gray-300 bg-white px-6 py-5"
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-end gap-4">
          <div className="flex min-w-[200px] flex-1 flex-col gap-1">
            <span className="text-sm font-medium">Tên sự kiện</span>
            <Input
              placeholder="Nhập từ khóa"
              value={values.keySearch}
              onChange={(e: { target: { value: string } }) =>
                set('keySearch', e.target.value)
              }
            />
          </div>
          <div className="flex min-w-[200px] flex-1 flex-col gap-1">
            <span className="text-sm font-medium">Trạng thái</span>
            <Select
              placeholder="Tất cả"
              value={values.status}
              onValueChange={(v) => set('status', Number(v))}
              allowClear
              className="w-full"
              options={[
                { value: 1, label: 'Hoạt động' },
                { value: 0, label: 'Không hoạt động' },
              ]}
            />
          </div>
          <div className="flex min-w-[200px] flex-1 flex-col gap-1">
            <span className="text-sm font-medium">Thời gian triển khai</span>
            <DateRangePicker
              value={values.time}
              onChange={(v) => set('time', v)}
              className="w-full"
            />
          </div>
          <div className="flex min-w-[200px] flex-1 flex-col gap-1">
            <span className="text-sm font-medium">Thời gian cập nhật</span>
            <DateRangePicker
              value={values.timeUpdate}
              onChange={(v) => set('timeUpdate', v)}
              className="w-full"
            />
          </div>
          <Button
            variant="outline"
            size="md"
            className="border-[#CE7A58] text-[#CE7A58] hover:bg-[#CE7A58]/10"
            onClick={onSearch}
          >
            <Search size={16} />
            Tìm kiếm
          </Button>
        </div>
      </div>
    </FilterFormWrapper>
  )
}
